export default function LocationPin(
	props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) {
	return (
		<svg
			width="28"
			height="28"
			viewBox="0 0 28 28"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M7.14757 20.397C4.3729 21.0223 2.57812 22.0178 2.57812 23.139C2.57812 25.0316 7.69265 26.5661 14.0017 26.5661C20.3108 26.5661 25.4253 25.0316 25.4253 23.139C25.4253 22.0178 23.6306 21.0223 20.8559 20.397"
				stroke="currentColor"
				strokeWidth="1.5"
			/>
			<path
				d="M14.572 10.0017H13.4297V8.85938H14.572V10.0017Z"
				stroke="currentColor"
				strokeWidth="1.5"
			/>
			<path
				d="M6.00781 9.47C6.00781 14.8272 14.0043 20.8542 14.0043 20.8542C14.0043 20.8542 22.0009 14.8272 22.0009 9.47C22.0009 5.03189 18.4207 1.43408 14.0043 1.43408C9.58798 1.43408 6.00781 5.03189 6.00781 9.47Z"
				stroke="currentColor"
				strokeWidth="1.5"
			/>
		</svg>
	)
}
